import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMapSlice } from '../../../slice';
import {
  selectMappedFieldsFilteredByCulture,
  selectMappedTempFields,
  selectTempPolygons,
} from '../../../slice/selectors';
import DisabledField from '../../fields/DisabledField/DisabledField';
import TempField from '../../fields/TempField/TempField';

interface IProps {}

const TempFields = (props: IProps) => {
  const dispatch = useDispatch();
  const { actions } = useMapSlice();

  const mappedTempFields = useSelector(selectMappedTempFields);
  const tempPolygons = useSelector(selectTempPolygons);
  const mappedFields = useSelector(selectMappedFieldsFilteredByCulture);

  useEffect(() => {
    if (mappedFields.length) {
      const coordArr = mappedFields.map(field => field.coordinates).flat(3);
      dispatch(actions.setFitCoordArrOnMap(coordArr));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, actions, mappedFields.length]);

  useEffect(() => {
    dispatch(actions.fitAllPolygonsOnMap());
  }, [tempPolygons, dispatch, actions]);

  return (
    <>
      {mappedTempFields.map(tempPolygon => (
        <TempField
          eventHandlers={{
            click() {
              dispatch(actions.toggleTempPolygon(tempPolygon.id));
            },
          }}
          tempPolygon={tempPolygon}
          key={tempPolygon.id}
          isSelected={tempPolygon.isSelected}
        />
      ))}
      {mappedFields.map(mappedField => (
        <DisabledField mappedField={mappedField} key={mappedField.id} />
      ))}
    </>
  );
};

export default TempFields;
